var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "boss-scout-send-container" },
        [
          _c("form-label", {
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _vm._v("\n        テンプレート\n        "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "メッセージテンプレートの作成・編集は、「各種設定」メニューで行えます。",
                            },
                            expression:
                              "{ content: 'メッセージテンプレートの作成・編集は、「各種設定」メニューで行えます。'}",
                          },
                        ],
                        staticClass: "pega-circle",
                      },
                      [_vm._v("?")]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "select",
                      {
                        staticClass: "boss-input-select",
                        domProps: { value: _vm.selectedTemplateId },
                        on: {
                          change: function ($event) {
                            return _vm.setSelectedTemplateMessage(
                              $event.target.value,
                              _vm.selectedTemplateId
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { "data-test": "template-option-none" },
                            domProps: { value: null },
                          },
                          [_vm._v("\n            指定なし\n          ")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.templates, function (template, i) {
                          return _c(
                            "option",
                            {
                              key: i,
                              attrs: { "data-test": "template-option-" + i },
                              domProps: { value: template.id },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(template.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("scout-mail-form", {
            attrs: { "check-template": true },
            on: { "change-invalid": _vm.changeInvalid },
            model: {
              value: _vm.innerMessage,
              callback: function ($$v) {
                _vm.innerMessage = $$v
              },
              expression: "innerMessage",
            },
          }),
          _vm._v(" "),
          _c("form-label", {
            attrs: { label: "送信日時" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("div", [
                      !_vm.reservationId
                        ? _c(
                            "label",
                            { staticClass: "pega-input display-inline-block" },
                            [
                              _c("input", {
                                staticClass: "boss-sent-radio",
                                attrs: {
                                  type: "radio",
                                  "data-test": "immediately",
                                },
                                domProps: {
                                  checked: _vm.isImmediately === true,
                                  value: true,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onImmediately(true)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "boss-sent-radio-text" },
                                [_vm._v("即時送信")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isScoutedForTransition
                        ? _c("div", [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "display-inline boss-annotation-text",
                                attrs: { "data-test": "scout-annotation-text" },
                              },
                              [
                                _vm._v(
                                  "※スカウト配信は1名につき1日1通までです。本日配信済みの会員は送信時に除外されます。"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "boss-sent-date" }, [
                      _c(
                        "label",
                        { staticClass: "pega-input display-inline-block" },
                        [
                          _c("input", {
                            staticClass: "boss-sent-radio",
                            attrs: {
                              type: "radio",
                              "data-test": "send-reservation",
                            },
                            domProps: {
                              checked: _vm.isImmediately === false,
                              value: false,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onImmediately(false)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "boss-sent-radio-text margin-right-1",
                            },
                            [_vm._v("送信日時の指定")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass:
                              "boss-send-subject width-25 display-inline ie-vertical-text-bottom",
                            attrs: {
                              placeholder: "スカウト送信予約名",
                              type: "text",
                              "data-test": "message-reservation-name",
                            },
                            domProps: { value: _vm.reservationName },
                            on: {
                              focusin: function ($event) {
                                return _vm.onImmediately(false)
                              },
                              input: function ($event) {
                                return _vm.$emit(
                                  "update:reservationName",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("date-picker", {
                            staticClass: "ie-vertical-text-bottom",
                            style: { width: "auto" },
                            attrs: {
                              value: _vm.sendDate,
                              type: "date",
                              "disabled-date": _vm.notTodayBetweenScoutEndDate,
                              "input-class": "pega-picker",
                              placeholder: "日付を選択",
                              editable: false,
                              "value-type": "YYYY-MM-DD",
                            },
                            on: { change: _vm.onUpdateDate },
                          }),
                          _vm._v(" "),
                          _c("date-picker", {
                            staticClass: "ie-vertical-text-bottom",
                            style: { width: "auto" },
                            attrs: {
                              value: _vm.sendTime,
                              "minute-step": 30,
                              "disabled-time": _vm.disabledTime,
                              "default-value": _vm.defaultTime,
                              type: "time",
                              "popup-class": "pega-custom-time-header",
                              placeholder: "時間を選択",
                              format: "HH:mm",
                              "input-class": "pega-picker",
                              editable: false,
                              "value-type": "HH:mm",
                            },
                            on: { change: _vm.onUpdateTime },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass: "display-inline boss-annotation-text",
                            attrs: { "data-test": "remind-sent" },
                          },
                          [_vm._v("※予約できる時間は7:00～21:00までです。")]
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.innerMessage.specialFavorIds.length > 0
        ? _c("accept-items", {
            attrs: {
              accepted: _vm.accepted,
              "notice-label":
                "以下のスカウト特典が設定されています。応募があった際は必ずご対応ください。",
            },
            on: {
              "update:accepted": function ($event) {
                _vm.accepted = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return _vm._l(
                      _vm.checkedSpecialFavors,
                      function (checkedSpecialFavor) {
                        return _c(
                          "div",
                          {
                            key: checkedSpecialFavor.id,
                            staticClass: "grid-x grid-margin-x",
                          },
                          [
                            _c(
                              "li",
                              {
                                attrs: {
                                  "data-test":
                                    "special-favor-warning-label-" +
                                    checkedSpecialFavor.id,
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(checkedSpecialFavor.name) +
                                    "：" +
                                    _vm._s(checkedSpecialFavor.description) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        )
                      }
                    )
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3260803956
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form-button-area",
        [
          _c("form-back-button", {
            attrs: { "data-test": "back-button" },
            on: {
              back: function ($event) {
                return _vm.$router.back()
              },
            },
          }),
          _vm._v(" "),
          _c("form-confirm-button", {
            attrs: {
              "is-disabled": _vm.isConfirmButtonDisabled,
              "submit-label": "送信内容を確認する",
              "data-test": "confirm-button",
            },
            on: {
              "submit-event": function ($event) {
                return _vm.$emit("show-detail")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }